"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dataAdmin = require("@/api/dataAdmin");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: [],
  data: function data() {
    return {
      dialogVisible1: false,
      tableData: [],
      statusObj: {
        0: '处理中',
        1: '已完成',
        2: '失败',
        3: '部分失败'
      }
    };
  },
  methods: {
    downFile: function downFile(val) {
      window.location.href = val;
    },
    open: function open(data) {
      var _this = this;
      console.log(data);
      (0, _dataAdmin.queryExportRecord)({
        page: 1,
        size: 20,
        recordType: 1,
        moduleId: 2,
        taskId: data.taskId
      }).then(function (res) {
        _this.tableData = res.data.data;
      });
      this.dialogVisible1 = true;
    },
    onClose: function onClose() {
      this.tableData = [];
      this.dialogVisible1 = false;
    }
  }
};